"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyles = void 0;
const __1 = require("../");
const styled_components_1 = require("styled-components");
const AppContext_1 = require("../utils/AppContext");
const customCssMixin = styled_components_1.css `
   ${props => (props.theme ? props.theme["custom-css"] : "")}
`;
exports.GlobalStyles = AppContext_1.withAppContext(styled_components_1.createGlobalStyle `
   
   @font-face {
      font-family: "Segoe UI";
      font-weight: 400;
      font-style: normal;
      font-display: auto;
      unicode-range: U+000-5FF; /* Load only Latin glyphs */
      src: local("Segoe UI"),
         url(${__1.SegoeWoff2}) format('woff2'),
         url(${__1.SegoeWoff}) format('woff');
   }
   body {
      ${customCssMixin}
      font-family: ${props => props.theme ? props.theme["font-family"] : null};
      -webkit-font-smoothing: antialiased;
      /* background: ${props => props.theme ? props.theme["body-background-color"] : "#fff"} */
      & *:not(td), & .k-textbox.k-textbox.k-textbox {
         border-radius: 3px 3px;
      }
   }
  & .k-icon.k-icon.k-icon {
      font-weight: bold;
      color: ${props => props.theme["app-link-color"]};
      &:hover, &:hover::before,
      .k-link:hover & {
         color: ${props => props.theme["hover-color"]};
      }
      &:active, &:active::before,
      .k-link:active & {
         color: ${props => props.theme["active-color"]};
      }
      &.disabled.disabled.disabled.disabled.disabled.disabled, .disabled.disabled.disabled.disabled.disabled.disabled & {
         color: ${props => props.theme["disabled-color"]};  
      }
   }
   
   & .k-label.k-label.k-label {
      color: rgba(0,0,0,0.6);
      font-family: ${props => props.theme["font-family"]};
      background-color: transparent;
   }
   & [disabled] *, .disabled.disabled.disabled.disabled.disabled.disabled *,
   .disabled.disabled.disabled.disabled.disabled.disabled + .k-label.k-label.k-label,
   [disabled] + .k-label.k-label.k-label,
   .k-state-disabled.k-state-disabled.k-state-disabled.k-state-disabled.k-state-disabled.k-state-disabled * {
      color: ${props => props.theme["disabled-color"]};  
   }
   & .k-state-invalid.k-state-invalid input,
   .k-state-invalid.k-state-invalid .k-searchbar,
   .k-state-invalid.k-state-invalid span
   {
      background: ${props => props.theme["validation-background-color"]};
       
   }
   .k-state-invalid.k-state-invalid .k-select {
      background: transparent;
   }
   &.k-state-invalid .k-label.k-label.k-label.k-label.k-label {
      color: ${props => props.theme["alert-color"]};
   }
   & .k-numerictextbox:hover > :not(.k-state-disabled) .k-link {
      opacity: .87;
   }
   && .alert {
      font-family: ${props => props.theme["font-family"]};
      &&.header {
            font-weight: bold;
            margin-right: 10px;
         }
      && span {
         color: ${props => props.theme["input-color"]};
      }
      &&.success {
         background: ${props => props.theme["alert-success-color"]};
      }
      &&.warning {
         background: ${props => props.theme["alert-warning-color"]};
      }
      &&.info {
         background: ${props => props.theme["alert-info-color"]};
      }
      &&.error {
         background: ${props => props.theme["alert-danger-color"]};
      }
      &&.default {
         && span {
            color: ${props => props.theme["action-button-hover-text-color"]};
         }
      }
      
   }
   
   & .k-state-selected .k-link.k-link.k-link, .k-widget.k-widget.k-widget ::selection,
    .k-list .k-state-selected.k-state-selected.k-state-selected,
     .k-list .k-item:hover.k-state-selected.k-state-selected.k-state-selected {
      color: ${p => p.theme["action-button-hover-text-color"]};
      background-color: ${p => p.theme["selected-background-color"]};
      border-color: ${p => p.theme["selected-background-color"]};
   }
   
   & .k-calendar .k-calendar-header > span.k-today, & .k-datetime-wrap .k-time-header button.k-time-now.k-time-now {
      font-weight: bold;
      color: ${props => props.theme["app-link-color"]};
      &:hover,
      .k-link:hover & {
         color: ${props => props.theme["hover-color"]};
      }
      &:active,
      .k-link:active & {
         color: ${props => props.theme["active-color"]};
      }
   }

   & .k-animation-container.k-animation-container {
      z-index: 10003
   }

   & .k-icon.k-clear-value.k-i-close {
      font-size: 20px;
      color: ${props => props.theme["app-link-color"]};
      &:hover,
      .k-link:hover & {
         color: ${props => props.theme["hover-color"]};
         opacity: 0.5;
      }
      &:active,
      .k-link:active & {
         color: ${props => props.theme["active-color"]};
      }
   }
   & .k-loading-mask.k-loading-mask.k-loading-mask, .k-loading-image.k-loading-image.k-loading-image, .k-loading-color.k-loading-color.k-loading-color {
      z-index: 100000;
   }
   & .k-textbox:disabled, .k-textbox[disabled], .k-textbox.k-state-disabled, .k-textbox:disabled, .k-textbox[disabled], .k-textbox.k-state-disabled, .k-select.k-select.k-select, .k-select.k-select.k-select * {
       opacity: inherit;
    }
    & .z-alert.z-alert.z-alert {
       z-index: 10999;
    }
   & .MuiTooltip-popper.MuiTooltip-popper {
         z-index: 11000;
      }

      & .MuiMenuItem-root.MuiMenuItem-root, & .MuiButtonBase-root {
         font-family: ${props => props.theme["font-family"]};
      }

   & .k-datetime-container, .k-calendar-container {
      ${(props) => props.appContext && props.appContext.isMobile
    ? `
            top: unset !important;
            bottom: 0px !important;
            `
    : null} 
   }
      
   & .k-pager-info.k-label, .k-pager-sizes.k-label {
      ${(props) => props.appContext && props.appContext.isMobile
    ? "display: none !important;"
    : null}
   }

   .k-pager-wrap.k-grid-pager {
      ${(props) => props.appContext && props.appContext.isMobile
    ? `
            height: 40px;
            width: 100vw;
            padding: 2px;
            margin: 0px 0px 6px 0px;
            align-items: center;
            justify-content: center;
            `
    : null}
   }
`);
//# sourceMappingURL=GlobalStyles.js.map